/**
 * Dados fictícios da grid de Processos.
 *
 * Os 12 primeiros números replicam o print `grid_icons_check.png` para que a
 * comparação lado a lado com a referência seja direta.
 *
 * Campos de alerta (mesma semântica de `AlertasProcesso` no projeto real):
 *   corAlertaFase   'V' no prazo | 'L' no limite | 'M' vencido | 'E' sem alerta
 *   compromisso     'MARCADO' | 'EXPIRACAO_PROXIMA' | 'EXPIRADO' | 'DISABLED'
 *   naoTrabalhado   boolean  → bolinha roxa
 *   requisicao      string|null → bandeira azul (o texto é o tooltip)
 *   pasta           string|null → ícone de pasta
 */

/** Ordem de exibição na tela, conforme o pedido. */
export const SITUACOES = [
  {
    id: 'SEM_PRAZO', label: 'Sem prazo', ordem: 1, cor: 'default',
  },
  {
    id: 'NAO_TRABALHADO', label: 'Não trabalhado', ordem: 2, cor: 'default',
  },
  {
    id: 'PRAZO_VENCIDO', label: 'Prazo vencido', ordem: 3, cor: 'error',
  },
  {
    id: 'PRAZO_DIA', label: 'Prazo do dia', ordem: 4, cor: 'warning',
  },
  {
    id: 'PRAZO_FUTURO', label: 'Prazo futuro', ordem: 5, cor: 'success',
  },
];

export const STATUS_OPTIONS = [
  'Ativo',
  'Unificado',
  'Incobrável',
  'Não Processado',
  'Não Estabelecido',
  'Recebido',
  'Pgto. Direto',
  'Baixa Requerida',
  'Duplicidade',
  'Ajuizado',
  'Indefinido',
];

export const CONDICAO_OPTIONS = [
  'Acordo não comprido',
  'Prazo Jurídico',
  'Prazo - Ligar para o devedor',
  'Prazo - Notificação E-mail',
  'Prazo – Visita ao Devedor',
  'Promessa – Pagamentos por boleto/PIX',
  'Promessa – Retorno',
  'Tarefa – Suspensão de cobrança',
];

/** Opções do 3º botão (ordenação) = colunas da grid. */
export const ORDENACAO_OPTIONS = [
  { id: 'nroProcesso', label: 'Processo' },
  { id: 'status', label: 'Status' },
  { id: 'situacao', label: 'Situação' },
  { id: 'valorPrincipal', label: 'Valor Principal' },
  { id: 'diasComProcesso', label: 'Dias com Processo' },
];

export const PROCESSOS = [
  {
    id: 1,
    nroProcesso: '327500',
    naoTrabalhado: false,
    compromisso: 'EXPIRACAO_PROXIMA',
    requisicao: 'Requisição de baixa',
    pasta: null,
    valorPrincipal: 955.0,
    corAlertaFase: 'V',
    diasFase: 14,
    status: 'Ativo',
    situacao: 'PRAZO_DIA',
    condicao: 'Promessa – Retorno',
    negociador: 'Murilo Andrade',
    nomeDevedor: 'Dois Irmãos Comércio Ltda',
    nomeCliente: 'Cliente Teste - Sprint 34',
    fase: 'Pós Auditoria',
    diasComProcesso: 118,
    dataAbertura: '12/02/2026',
    uf: 'SP',
    cidade: 'São Paulo',
  },
  {
    id: 2,
    nroProcesso: '328361',
    naoTrabalhado: true,
    compromisso: 'EXPIRADO',
    requisicao: null,
    pasta: 'Pasta 12',
    valorPrincipal: 3483.0,
    corAlertaFase: 'M',
    diasFase: 21,
    status: 'Ativo',
    situacao: 'PRAZO_VENCIDO',
    condicao: 'Acordo não comprido',
    negociador: 'Maomao Silva',
    nomeDevedor: 'Metalúrgica Aurora S/A',
    nomeCliente: 'Cliente Fictício para Testes',
    fase: 'NT',
    diasComProcesso: 240,
    dataAbertura: '03/12/2025',
    uf: 'MG',
    cidade: 'Belo Horizonte',
  },
  {
    id: 3,
    nroProcesso: '328566',
    naoTrabalhado: false,
    compromisso: 'MARCADO',
    requisicao: 'Requisição de acordo',
    pasta: null,
    valorPrincipal: 3114.07,
    corAlertaFase: 'V',
    diasFase: 0,
    status: 'Ativo',
    situacao: 'PRAZO_FUTURO',
    condicao: 'Promessa – Pagamentos por boleto/PIX',
    negociador: 'Gabriela do Nascimento Pereira',
    nomeDevedor: 'Transportes Vale Verde ME',
    nomeCliente: 'Cliente Teste - Sprint 34',
    fase: 'Auditoria',
    diasComProcesso: 61,
    dataAbertura: '18/06/2026',
    uf: 'PR',
    cidade: 'Curitiba',
  },
  {
    id: 4,
    nroProcesso: '3289123',
    naoTrabalhado: false,
    compromisso: 'MARCADO',
    requisicao: null,
    pasta: 'Pasta 04',
    valorPrincipal: 914.81,
    corAlertaFase: 'V',
    diasFase: 6,
    status: 'Ativo',
    situacao: 'PRAZO_FUTURO',
    condicao: 'Prazo - Ligar para o devedor',
    negociador: 'Murilo Andrade',
    nomeDevedor: 'Padaria Central Eireli',
    nomeCliente: 'Distribuidora Norte',
    fase: 'NT',
    diasComProcesso: 95,
    dataAbertura: '20/04/2026',
    uf: 'SP',
    cidade: 'Campinas',
  },
  {
    id: 5,
    nroProcesso: '3283115',
    naoTrabalhado: true,
    compromisso: 'EXPIRACAO_PROXIMA',
    requisicao: null,
    pasta: null,
    valorPrincipal: 2754.81,
    corAlertaFase: 'M',
    diasFase: 16,
    status: 'Ajuizado',
    situacao: 'PRAZO_DIA',
    condicao: 'Prazo Jurídico',
    negociador: 'Carlos Henrique Lima',
    nomeDevedor: 'Construtora Horizonte Ltda',
    nomeCliente: 'Cliente Fictício para Testes',
    fase: 'Jurídico',
    diasComProcesso: 310,
    dataAbertura: '11/10/2025',
    uf: 'RJ',
    cidade: 'Rio de Janeiro',
  },
  {
    id: 6,
    nroProcesso: '3290185',
    naoTrabalhado: false,
    compromisso: 'EXPIRADO',
    requisicao: 'Requisição de desconto',
    pasta: null,
    valorPrincipal: 2787.76,
    corAlertaFase: 'M',
    diasFase: 21,
    status: 'Ativo',
    situacao: 'PRAZO_VENCIDO',
    condicao: 'Prazo - Notificação E-mail',
    negociador: 'Débora Thomaz Martins',
    nomeDevedor: 'Auto Peças Rodovia',
    nomeCliente: 'Cliente Teste - Sprint 34',
    fase: 'Pós Auditoria',
    diasComProcesso: 187,
    dataAbertura: '13/02/2026',
    uf: 'SP',
    cidade: 'Ribeirão Preto',
  },
  {
    id: 7,
    nroProcesso: '3290587',
    naoTrabalhado: true,
    compromisso: 'MARCADO',
    requisicao: null,
    pasta: 'Pasta 07',
    valorPrincipal: 1311.84,
    corAlertaFase: 'V',
    diasFase: 9,
    status: 'Recebido',
    situacao: 'PRAZO_FUTURO',
    condicao: 'Promessa – Retorno',
    negociador: 'Maomao Silva',
    nomeDevedor: 'Supermercado Bom Preço',
    nomeCliente: 'Distribuidora Norte',
    fase: 'NT',
    diasComProcesso: 72,
    dataAbertura: '07/06/2026',
    uf: 'BA',
    cidade: 'Salvador',
  },
  {
    id: 8,
    nroProcesso: '3290686',
    naoTrabalhado: true,
    compromisso: 'EXPIRADO',
    requisicao: null,
    pasta: 'Pasta 07',
    valorPrincipal: 1381.96,
    corAlertaFase: 'M',
    diasFase: 23,
    status: 'Incobrável',
    situacao: 'PRAZO_VENCIDO',
    condicao: 'Tarefa – Suspensão de cobrança',
    negociador: 'Murilo Andrade',
    nomeDevedor: 'Farmácia Popular ME',
    nomeCliente: 'Cliente Fictício para Testes',
    fase: 'Auditoria',
    diasComProcesso: 401,
    dataAbertura: '14/07/2025',
    uf: 'GO',
    cidade: 'Goiânia',
  },
  {
    id: 9,
    nroProcesso: '3292888',
    naoTrabalhado: false,
    compromisso: 'EXPIRACAO_PROXIMA',
    requisicao: 'Requisição de baixa',
    pasta: null,
    valorPrincipal: 1015.05,
    corAlertaFase: 'M',
    diasFase: 20,
    status: 'Baixa Requerida',
    situacao: 'PRAZO_DIA',
    condicao: 'Acordo não comprido',
    negociador: 'Gabriela do Nascimento Pereira',
    nomeDevedor: 'Oficina Mecânica Diesel',
    nomeCliente: 'Cliente Teste - Sprint 34',
    fase: 'NT',
    diasComProcesso: 156,
    dataAbertura: '15/03/2026',
    uf: 'SC',
    cidade: 'Joinville',
  },
  {
    id: 10,
    nroProcesso: '3293181',
    naoTrabalhado: true,
    compromisso: 'MARCADO',
    requisicao: null,
    pasta: null,
    valorPrincipal: 1030.0,
    corAlertaFase: 'V',
    diasFase: 6,
    status: 'Unificado',
    situacao: 'PRAZO_FUTURO',
    condicao: 'Prazo – Visita ao Devedor',
    negociador: 'Carlos Henrique Lima',
    nomeDevedor: 'Gráfica Modelo Ltda',
    nomeCliente: 'Distribuidora Norte',
    fase: 'Pós Auditoria',
    diasComProcesso: 88,
    dataAbertura: '22/05/2026',
    uf: 'RS',
    cidade: 'Porto Alegre',
  },
  {
    id: 11,
    nroProcesso: '3293352',
    naoTrabalhado: true,
    compromisso: 'EXPIRADO',
    requisicao: 'Requisição de acordo',
    pasta: null,
    valorPrincipal: 11523.65,
    corAlertaFase: 'M',
    diasFase: 23,
    status: 'Ativo',
    situacao: 'PRAZO_VENCIDO',
    condicao: 'Prazo Jurídico',
    negociador: 'Débora Thomaz Martins',
    nomeDevedor: 'Indústria Química Delta S/A',
    nomeCliente: 'Cliente Fictício para Testes',
    fase: 'Jurídico',
    diasComProcesso: 275,
    dataAbertura: '16/11/2025',
    uf: 'SP',
    cidade: 'Santo André',
  },
  {
    id: 12,
    nroProcesso: '3294894',
    naoTrabalhado: true,
    compromisso: 'EXPIRADO',
    requisicao: null,
    pasta: null,
    valorPrincipal: 1481.68,
    corAlertaFase: 'M',
    diasFase: 20,
    status: 'Pgto. Direto',
    situacao: 'NAO_TRABALHADO',
    condicao: 'Promessa – Retorno',
    negociador: 'Maomao Silva',
    nomeDevedor: 'Hotel Boa Vista Ltda',
    nomeCliente: 'Cliente Teste - Sprint 34',
    fase: 'NT',
    diasComProcesso: 44,
    dataAbertura: '05/07/2026',
    uf: 'ES',
    cidade: 'Vitória',
  },
];

// ###### Dados das abas do painel direito ######

export const CALCULO_PROCESSO = {
  principal: 16900000,
  protesto: 0,
  multa: 0,
  subtotal: 16900.0,
  jurosDesp: 16900000,
  honorarios: 7028.8,
  desconto: 0,
  total: 40828.8,
  renegociado: 0,
};

export const ANTECEDENTES = [
  { numero: '3245597', responsavel: 'Grupo Antonio Fase 6', status: 'Ativo' },
  { numero: '3252368', responsavel: '<Ninguém>', status: 'Unificado' },
  { numero: '3252417', responsavel: '<Ninguém>', status: 'Unificado' },
  { numero: '3255722', responsavel: '<Ninguém>', status: 'Unificado' },
  { numero: '3255723', responsavel: '<Ninguém>', status: 'Unificado' },
  { numero: '3268504', responsavel: 'Grupo Antonio Fase 6', status: 'Ativo' },
  { numero: '3268548', responsavel: 'Grupo Antonio Fase 6', status: 'Ativo' },
];

export const TITULOS_PROCESSO = [
  {
    seq: 1, tipo: 'NF', numero: '016071311-6', vencimento: '20/04/2026', atraso: 92, valorOriginal: 1869.34, saldo: 1869.34, protesto: 0,
  },
  {
    seq: 2, tipo: 'NF', numero: '016096022-6', vencimento: '25/04/2026', atraso: 87, valorOriginal: 526.6, saldo: 526.6, protesto: 0,
  },
  {
    seq: 3, tipo: 'NF', numero: '016071311-6', vencimento: '25/04/2026', atraso: 87, valorOriginal: 1869.34, saldo: 1869.34, protesto: 0,
  },
  {
    seq: 4, tipo: 'NF', numero: '016096022-6', vencimento: '30/04/2026', atraso: 82, valorOriginal: 526.6, saldo: 526.6, protesto: 0,
  },
  {
    seq: 5, tipo: 'DP', numero: '023487234-8', vencimento: '10/05/2026', atraso: 72, valorOriginal: 3120.0, saldo: 3120.0, protesto: 0,
  },
];

export const HISTORICO = [
  {
    data: '07/10/2002 - 16:06 hs', autor: 'Neuza', comentarios: 'Este processo é de teste.', extra: 'Não excluir (Processo enviado para Alessandra)',
  },
  {
    data: '24/10/2002 - 14:09 hs', autor: 'Fernanda', comentarios: null, extra: 'Enviada carta do tipo Especial',
  },
  {
    data: '05/11/2002 - 09:15 hs',
    autor: 'Alessandra',
    comentarios: 'Este processo não é mais teste. Existe processo e envelope com documentos encontra-se com o Armando',
    extra: '(Processo enviado para Arnaldo)',
  },
  {
    data: '13/11/2002 - 09:25 hs', autor: 'Fernanda', comentarios: null, extra: 'Enviada carta do tipo Especial',
  },
  {
    data: '13/11/2002 - 09:33 hs', autor: 'Arnaldo', comentarios: 'Não foi enviada carta ao devedor, a mesma só foi emitida para teste. Desconsiderar informação de 13/11/02.', extra: null,
  },
];

export const RECEBIMENTOS = [
  {
    numero: 36, data: '17/07/2026', fase: 'NT', negociador: 'Gabriela do Nascimento Pereira', statusCor: 'error', formaPagamento: 'Cartão', valor: 99405.52,
  },
  {
    numero: 35, data: '16/07/2026', fase: 'NT', negociador: 'Gabriela do Nascimento Pereira', statusCor: 'warning', formaPagamento: 'Boleto', valor: 95349.31,
  },
  {
    numero: 34, data: '06/07/2026', fase: 'NT', negociador: 'Gabriela do Nascimento Pereira', statusCor: 'warning', formaPagamento: 'Boleto', valor: 94949.51,
  },
  {
    numero: 33, data: '06/07/2026', fase: 'NT', negociador: 'Gabriela do Nascimento Pereira', statusCor: 'warning', formaPagamento: 'Boleto', valor: 94629.65,
  },
  {
    numero: 32, data: '17/06/2026', fase: 'NT', negociador: 'Gabriela do Nascimento Pereira', statusCor: 'warning', formaPagamento: 'Boleto', valor: 93110.37,
  },
];

export const RESUMO_ACORDOS = [
  { label: 'Acordos quitados', total: 0 },
  { label: 'Acordos Ativos', total: 0 },
  { label: 'Acordos Quebrados', total: 30 },
  { label: 'Simulações', total: 5 },
  { label: 'Propostas', total: 1 },
];

export const LANCAMENTOS_FINANCEIROS = [
  {
    data: '06/11/2025', historico: 'Início da Ficha (Neuza)', devedor: 169048.08, cliente: 136656.07, hb: 32392.01,
  },
  {
    data: '06/11/2025', historico: 'BO-001', devedor: 10000.0, cliente: 8083.85, hb: 1916.15,
  },
  {
    data: '12/12/2025', historico: 'BO-002', devedor: 20115.55, cliente: 16261.13, hb: 3854.42,
  },
  {
    data: '05/02/2026', historico: 'BO-001', devedor: 5000.0, cliente: 4041.93, hb: 958.07,
  },
  {
    data: '05/03/2026', historico: 'BO-002', devedor: 17042.79, cliente: 13777.15, hb: 3265.64,
  },
];

export const SALDOS = {
  atuais: { devedor: 98746.42, cliente: 80714.86, hb: 19031.56 },
  pagos: { devedor: 69301.66, cliente: 55941.21, hb: 13360.45 },
};

export const DOCUMENTOS = [
  {
    id: 1, extensao: 'ico', tipo: '', descricao: '', nomeArquivo: 'imagem 5.ico', originalArquivada: false, oculto: false, data: '22/03/2022',
  },
  {
    id: 2, extensao: '123', tipo: '123', descricao: '', nomeArquivo: 'teste.teste', originalArquivada: false, oculto: true, data: '22/03/2022',
  },
  {
    id: 3, extensao: '123', tipo: '', descricao: '', nomeArquivo: 'teste.teste', originalArquivada: true, oculto: true, data: '14/03/2022',
  },
  {
    id: 4, extensao: 'Teste', tipo: '', descricao: 'Why do we use it?', nomeArquivo: 'Teste de retorno', originalArquivada: true, oculto: false, data: '09/05/2022',
  },
  {
    id: 5, extensao: 'Imagem', tipo: 'teste1', descricao: '', nomeArquivo: 'azul-baloes.png', originalArquivada: false, oculto: false, data: '20/07/2022',
  },
  {
    id: 6, extensao: 'pdf', tipo: 'contrato', descricao: 'Contrato assinado', nomeArquivo: 'contrato-3290185.pdf', originalArquivada: true, oculto: false, data: '02/08/2026',
  },
];

export const EMAILS = [
  {
    dia: '20/08/2024 - Terça-feira',
    itens: [
      {
        data: '20/08/2024 - 16:44',
        autor: 'Debora - Débora Thomaz Martins - debora.gonzales@technosoftware.com.br',
        faseAtual: 'Pós Auditoria',
        corpo: 'O e-mail com a notificação no modelo Normal foi enviado com sucesso ao devedor no endereço techno1@abe.com.br.',
      },
      {
        data: '20/08/2024 - 16:44',
        autor: 'Debora - Débora Thomaz Martins - debora.gonzales@technosoftware.com.br',
        faseAtual: 'Pós Auditoria',
        /* eslint-disable max-len */
        corpo: `À
Dois irmãos @@
CPF/CNPJ: 40814376886
PROC. INTERNO: 1000
Cliente Teste - Sprint 34
TÍTULO(S): DP-23487234897 DP-23487234897

Prezados(as) Senhores(as),

Pelo presente, NOTIFICAMOS V.Sa(s) que o débito acima identificado foi-nos entregue para as providências judiciais, no valor atualizado de R$22.075,94, já inclusos despesas extrajudiciais e honorários advocatícios, conforme disposto nos artigos 389 e 395 do Código Civil brasileiro.

Para facilitar e evitar a sequência jurídica, o referido débito deverá ser pago pelo boleto anexo, até a data de vencimento nele indicada.`,
        /* eslint-enable max-len */
      },
    ],
  },
];

export const RECALCULOS = [
  {
    dataRecalculo: '16/02/2021', dataBase: '16/02/2021', fase: 'Robô', responsavel: '<Sistema>', motivo: 'Abertura de Processo', tipoDesconto: 'Sem desconto', valor: 16900.0,
  },
  {
    dataRecalculo: '22/09/2022', dataBase: '22/09/2022', fase: 'NT', responsavel: 'Carlos Henrique Lima', motivo: 'Mudança de Fase', tipoDesconto: 'Sem desconto', valor: 18240.55,
  },
  {
    dataRecalculo: '12/07/2023', dataBase: '12/07/2023', fase: 'NT', responsavel: 'Débora Thomaz Martins', motivo: 'Mudança de Fase', tipoDesconto: 'Percentual', valor: 21390.12,
  },
  {
    dataRecalculo: '23/04/2024', dataBase: '23/04/2024', fase: 'NT', responsavel: 'Débora Thomaz Martins', motivo: 'Acordo', tipoDesconto: 'Faixa de desconto', valor: 24880.4,
  },
  {
    dataRecalculo: '09/10/2024', dataBase: '09/10/2024', fase: 'Adv. Externo', responsavel: 'Débora Thomaz Martins', motivo: 'Mudança de Fase', tipoDesconto: 'Sem desconto', valor: 30115.9,
  },
];

export const FASES_TIMELINE = [
  {
    nome: 'Pós Auditoria', atual: true, entrada: '30/05/2026 - 01:01:08', trabalhado: '30/05/2026 - 01:01:08', saida: '', negociador: 'Murilo',
  },
  {
    nome: 'Pós Auditoria', atual: false, entrada: '30/05/2026 - 01:01:08', trabalhado: '30/05/2026 - 01:01:08', saida: '', negociador: 'Murilo',
  },
  {
    nome: 'NT', atual: false, entrada: '10/02/2026 - 14:07:29', trabalhado: '10/02/2026 - 14:07:29', saida: '30/05/2026 - 01:01:08', negociador: 'Murilo',
  },
  {
    nome: 'NT', atual: false, entrada: '10/02/2026 - 14:07:29', trabalhado: '10/02/2026 - 14:07:29', saida: '30/05/2026 - 01:01:08', negociador: 'Maomao',
  },
  {
    nome: 'Auditoria', atual: false, entrada: '03/02/2026 - 15:52:54', trabalhado: '03/02/2026 - 15:52:54', saida: '10/02/2026 - 14:07:29', negociador: 'Maomao',
  },
  {
    nome: 'Auditoria', atual: false, entrada: '28/01/2026 - 09:12:00', trabalhado: '28/01/2026 - 09:12:00', saida: '03/02/2026 - 15:52:54', negociador: 'Maomao',
  },
];

/** Menu lateral direito da tela de Controle de Processos, na ordem pedida. */
export const MENU_PROCESSO = [
  { id: 'acompanhamento', label: 'Acompanhamento' },
  { id: 'historico', label: 'Histórico' },
  { id: 'recebimento', label: 'Recebimento' },
  { id: 'financeira', label: 'Financeira' },
  { id: 'documentos', label: 'Documentos' },
  { id: 'email', label: 'E-mail' },
  { id: 'devedor', label: 'Devedor' },
  { id: 'cliente', label: 'Cliente' },
  { id: 'recalculos', label: 'Recálculos do Processo' },
  { id: 'juridico', label: 'Dados Jurídicos' },
  { id: 'fases', label: 'Fases' },
];
